// extracted by mini-css-extract-plugin
export default {"dropdown":"dropdown_dropdown__sU7iP","dropdown__btn":"dropdown_dropdown__btn__JjIwp","dropdown__content":"dropdown_dropdown__content__cV9UD"};